import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LabelService } from 'src/app/_services/label.service';

@Component({
  selector: 'app-label-duzenle',
  templateUrl: './label-duzenle.component.html',
  styleUrls: ['./label-duzenle.component.css']
})
export class LabelDuzenleComponent implements OnInit {

  constructor( 
    private labelService:LabelService,
    private formBuilder:FormBuilder,
    private activeModal:NgbActiveModal,
    private toastr: ToastrService
  ) { }
  submitted=false;
  @Input() label:any;
  definitionForm:FormGroup;
  ngOnInit() {

    this.definitionForm = this.formBuilder.group({
      prompt: ['', Validators.required],
      labelId:[this.label.id]
    });
  }
  close(){
    this.activeModal.close();
  }

  save(){
    

      if(!this.definitionForm.valid){
       
          this.toastr.error('','Lütfen prompt alanını doldurun!');
       
          return;
      }

      this.submitted=true;

      this.labelService.yeniprompt(this.definitionForm.value).subscribe(res=>{
        this.toastr.success('','Etiket yeniden oluşturuldu!');
          this.activeModal.close();
         
      },err=>{
        this.toastr.error('','Etiket oluşturma sırasında hata oluştu!');
      });
  }

}
